import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import ClaimsCenter from './components/ClaimsCenter';
import Credentials from './components/Credentials';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import './styles.css'; // Import the main CSS file



function App() {
  return (
    <div style={{ 
    WebkitFontSmoothing: 'antialiased', /* For WebKit browsers like Chrome/Safari */
    MozOsxFontSmoothing: 'grayscale',  /* For Firefox */
    color: '#1e293b' /* A dark slate gray color similar to text-slate-800 */
  }}>
      <Header />
      <main>
        <Hero />
        <Services />
        <ClaimsCenter />
        <Credentials />
        <section id="resources" className="max-w-7xl mx-auto px-6" style={{ paddingTop: '4rem', paddingBottom: '4rem' }}>
          <h2 style={{ fontSize: '1.875rem', fontWeight: '700', textAlign: 'center', marginBottom: '2.5rem' }}>
            Technical Resources & Insights
          </h2>
          <div className="grid-cols-1-md-2">
            <article style={{ padding: '1.25rem', border: '1px solid #e5e7eb', borderRadius: '0.5rem', transition: 'all 0.3s' }}>
              <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.5rem' }}>
                Case Study: Collision Liability Adjustment
              </h3>
              <p style={{ color: '#475569' }}>
                Detailed breakdown of a complex two-vessel collision, including
                apportionment of fault, legal context, and successful settlement
                outcomes. (Anonymized)
              </p>
            </article>
            <article style={{ padding: '1.25rem', border: '1px solid #e5e7eb', borderRadius: '0.5rem', transition: 'all 0.3s' }}>
              <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.5rem' }}>
                Case Law Updates in Marine Insurance Law
              </h3>
              <p style={{ color: '#475569' }}>
                Concise summary of new safety and procedural requirements
                affecting cargo documentation and ship management systems (SMS).
              </p>
            </article>
          </div>
        </section>
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}

export default App;